import { useRef } from 'react'
import { Slider as BaseSlider } from 'swp-components/lib/components/common'

import useCenteredSlides from './use-centered-slides'
import useDraggable from './use-draggable'
import useNavigation from './use-navigation'
import usePosition from './use-position'
import useSlide from './use-slide'
import useSpec from './use-spec'

const Slider = ({ color, options = {}, children, ...props }) => {
  let containerRef = useRef(null)
  let trayRef = useRef(null)

  let { spec } = useSpec(options)
  let { position, setPosition } = usePosition()
  let { centered } = useCenteredSlides(containerRef, trayRef)

  let { eventHandlers } = useDraggable(
    containerRef,
    trayRef,
    position,
    setPosition
  )

  let { arrow, moveSlide } = useNavigation(
    containerRef,
    trayRef,
    position,
    setPosition
  )

  useSlide(containerRef, trayRef, spec)

  let ref = useRef({ containerRef, trayRef })
  let slider = {
    spec,
    centered,
    eventHandlers,
    arrow,
    moveSlide,
  }

  return (
    <BaseSlider ref={ref} color={color} slider={slider} {...props}>
      {children}
    </BaseSlider>
  )
}

export default Slider
